import axios from "axios";
import getEnv from "@/config/env";

let api = axios.create({
    baseURL: getEnv("VUE_APP_BACKEND_API")
})

export default api;